export default __webpack_public_path__ + "static/reporting-granular-2693ea731ccbbb4cdb650b5732943949.png";